module.exports = __webpack_public_path__ + "static/Tailie-75571ad3a8caf0b889c5103cd53d034b.png";